import { CartUpdateEvent } from '@theme/events';

class PoiseAddons extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.addEventListener('change', (event) => this.onChange(event));
    this.updateTotal();
  }

  selectedItems() {
    return [...this.querySelectorAll('[data-addon-check]:checked:not(:disabled)')]
      .map((input) => ({ id: Number(input.value), quantity: 1 }));
  }

  money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'code',
    }).format(cents / 100);
  }

  updateTotal() {
    const total = this.querySelector('[data-addon-total]');
    if (!total) return;
    const cents = [...this.querySelectorAll('[data-addon-check]:checked')]
      .reduce((sum, input) => sum + Number(input.closest('[data-addon-row]').querySelector('[data-addon-price]').dataset.price), 0);
    total.textContent = this.money(cents);
  }

  onChange(event) {
    const input = event.target;
    if (input.matches('[data-addon-variant]')) {
      const row = input.closest('[data-addon-row]');
      const option = input.selectedOptions[0];
      const check = row.querySelector('[data-addon-check]');
      const price = row.querySelector('[data-addon-price]');
      check.value = option.value;
      check.disabled = option.dataset.available !== 'true';
      if (check.disabled) check.checked = false;
      const previewPrice = Math.round(Number(option.dataset.price) * 0.8);
      price.dataset.price = String(previewPrice);
      price.textContent = this.money(previewPrice);
      row.querySelector('[data-addon-original]').textContent = this.money(Number(option.dataset.price));
      if (option.dataset.image) {
        const image = row.querySelector('img');
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
    }
    this.updateTotal();
    if (this.dataset.mode === 'cart' && input.matches('[data-addon-check]')) this.updateCart(input);
  }

  async updateCart(input) {
    const root = window.Shopify?.routes?.root || '/';
    const containers = [...document.querySelectorAll('cart-items-component[data-section-id]')];
    const sections = [...new Set(containers.map((node) => node.dataset.sectionId))].slice(0, 5);
    const widgets = [...document.querySelectorAll('poise-addons[data-mode="cart"]')];
    const checkoutButtons = [...document.querySelectorAll('[name="checkout"]')];
    const locked = [...widgets.flatMap((widget) => [...widget.querySelectorAll('input,select')]), ...checkoutButtons];
    const states = locked.map((element) => [element, element.disabled]);
    const status = this.querySelector('[data-addon-status]');
    const desired = input.checked;
    widgets.forEach((widget) => widget.setAttribute('aria-busy', 'true'));
    locked.forEach((element) => { element.disabled = true; });
    try {
      const cartResponse = await fetch(`${root}cart.js`);
      if (!cartResponse.ok) throw new Error(this.dataset.error);
      const cart = await cartResponse.json();
      const productId = Number(input.closest('[data-addon-row]').dataset.productId);
      const existing = cart.items.filter((item) => item.product_id === productId);
      let response;
      if (desired && !existing.length) {
        response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }], sections, sections_url: window.location.pathname }),
        });
      } else if (!desired && existing.length) {
        response = await fetch(`${root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: Object.fromEntries(existing.map((item) => [item.key, 0])), sections, sections_url: window.location.pathname }),
        });
      } else {
        window.location.reload();
        return;
      }
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      const updatedResponse = await fetch(`${root}cart.js`);
      if (!updatedResponse.ok) { window.location.reload(); return; }
      const updatedCart = await updatedResponse.json();
      if (!sections.length || sections.some((id) => !result.sections?.[id])) { window.location.reload(); return; }
      document.dispatchEvent(new CartUpdateEvent(updatedCart, 'poise-addons', {
        source: 'poise-addons', itemCount: updatedCart.item_count, sections: result.sections,
      }));
      status.textContent = this.dataset.updated;
    } catch (error) {
      input.checked = !desired;
      status.textContent = error.message || this.dataset.error;
    } finally {
      states.forEach(([element, disabled]) => { element.disabled = disabled; });
      widgets.forEach((widget) => widget.removeAttribute('aria-busy'));
      document.querySelectorAll('poise-addons[data-mode="cart"] [data-addon-variant]').forEach((select) => {
        select.disabled = select.closest('[data-addon-row]').querySelector('[data-addon-check]').checked;
      });
    }
  }
}

if (!customElements.get('poise-addons')) customElements.define('poise-addons', PoiseAddons);
